import React from 'react';
import { observer } from 'mobx-react';
import { Modal, StackLayout, useModalStore, Button } from '@wemogy/reactbase';
import useAuthorizationStore from '../../../hooks/UseAuthorizationStore';
import RoleEditor from '../roleEditor/RoleEditor';
import { getSnapshot } from 'mobx-state-tree';
var ManageRoleModal = function () {
    var authorizationStore = useAuthorizationStore();
    var manageRoleModal = authorizationStore.config.ui.manageRoleModal;
    var roleStore = authorizationStore.roleStore;
    var modalStore = useModalStore();
    var parameters = modalStore.getActiveParameters('manageRoleModal');
    if (!parameters) {
        return null;
    }
    var role = parameters.role, mode = parameters.mode;
    return (React.createElement(Modal, { modalKey: "manageRoleModal", title: manageRoleModal.titles[mode], variationKey: manageRoleModal.modalVariation, onSave: function () {
            if (mode === 'create') {
                console.log('CRATE', getSnapshot(role));
                roleStore.create(role)
                    .then(function () {
                    console.log('created');
                    modalStore.closeModal();
                });
            }
            else {
                var patch = role.commitChanges();
                if (!patch) {
                    return;
                }
                roleStore.patch(role.id, patch).then(function () {
                    modalStore.closeModal();
                });
            }
        }, onClosePressed: role.discardChanges, widthFitContent: true },
        React.createElement(StackLayout, null,
            React.createElement(RoleEditor, { role: role }),
            mode === 'edit' && false ? React.createElement(Button, { onPress: function () {
                    // ToDo: replace with react-base component
                    var confirmed = window.confirm('Wollen Sie die Rolle wirklich löschen?');
                    if (!confirmed) {
                        return;
                    }
                    roleStore.delete(role.id).then(modalStore.closeModal);
                } }, "Rolle l\u00F6schen") : null)));
};
export default observer(ManageRoleModal);
//# sourceMappingURL=ManageRoleModal.js.map